import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDroplet = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.75 12.397s3.08 2.838 3.034 5.686v.004c.031 1.621-1.531 2.802-3.033 2.783-1.502.019-3.065-1.162-3.033-2.783v-.004c-.046-2.848 3.033-5.686 3.033-5.686M5.936 4.583s3.08 2.838 3.033 5.686v.004c.032 1.621-1.53 2.802-3.033 2.783-1.502.019-3.064-1.162-3.033-2.783v-.004c-.046-2.848 3.033-5.686 3.033-5.686M18.144 3.13s2.998 2.763 2.953 5.537v.003c.031 1.579-1.49 2.729-2.953 2.71-1.463.019-2.984-1.131-2.953-2.71v-.003c-.045-2.774 2.953-5.537 2.953-5.537"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgDroplet);
export default ForwardRef;
